module.exports = __webpack_public_path__ + "static/media/product_07.00a6dee7.jpg";